import { LoadingButton, TabContext, TabList, TabPanel } from "@mui/lab";
import {
  Box,
  Card,
  CardContent,
  Chip,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  styled,
  Tab,
  Tooltip
} from "@mui/material";
import BsModal from "../BaseModal";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hasAuthority } from "../../../../utils/authorities";
import { dateFormater } from "../../../utils/common/utils";
import { RenderTooltipContent } from "./renderTooltip";
import { HistoryIcon, FreshIcon, Cryopreserve, PoolIcon } from "../../../assets/CommonSvg";
import HistoryDrawer from "./historyDrawer";
import { selectVienToVienLoading } from "../../../slices/logisticSlice";
import { selectManufactureProductLoading } from "../../../slices/manufacturer";
import { changeV2VCycle, selectActiveV2VCycle, selectCurrentCycle, selectV2VCycle } from "../../../slices/common";
import { clearActiveTaskSlug, selectActiveTaskSlug } from "../../../slices/help";
import RestartManufacturingForm from "./RestartManufacturingForm";
import StartManufacturingForm from "./StartManufacturingForm";
import ReferenceSection from "../Information/ReferenceSection"
import InfusionDateForm from "./InfusionForm";
import CompleteInfusionForm from "./CompleteInfusionForm";
import MarkAsCompleteForm from './MarkAsCompleteForm'
import { truncateText, checkCRExist, hasCRPermission } from "../../../../utils/utils"
import { useSearchParams } from 'react-router-dom';
import CryoLsmFormDialog from "../../features/ManufacturingForm/Common/CryoLsmFormDialog";
import BatchReleaseCertificate from "../../../pages/Manufacturer/print/BatchReleaseCertificate"
import { selectDeliveryActivePartnersAll } from "../../../slices/deliveryPartners"
import { slugMap, CR_TEXT } from "../../../utils/common/utils"

const StepStatus = {
  0: "Pending",
  1: "In-progress",
  2: "Completed",
  3: "Rejected",
  4: "Submitted ",
  5: "Submitted for review",
  6: "LSM cryopreserved"
};

const StepStatusColor = {
  0: "text-gray-600",
  1: "text-yellow-500",
  2: "text-green-600",
  3: "text-red-600",
  4: "text-yellow-500",
  5: "text-yellow-600",
  6: "text-yellow-500",
};
const CycleStatusColor = {
  0: "text-red-600",
  1: "text-green-600",
  2: "text-red-600",
};
const CycleStatus = {
  0: "In-Active",
  1: "Active",
  2: "Terminate",
};
const BarConnector = styled(StepConnector)(() => ({
  "& .MuiStepConnector-line": {
    height: 3,
    borderRadius: 2,
    border: "none",
    backgroundColor: "#CFD6DC",
    marginLeft: "-50%",
    marginRight: "55%",
    marginTop: "-3px",
  },
}));

const StepIconWrapper = styled("div")(({ completed }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: 20,
  height: 20,
  borderRadius: "50%",
  backgroundColor: completed ? "transparent" : "#CFD6DC",
  border: completed ? "1px solid #3571FF" : "none",
}));

const InnerCircle = styled("div")(({ completed }) => ({
  width: 12,
  height: 12,
  borderRadius: "50%",
  backgroundColor: completed ? "#3571FF" : "transparent",
}));

const STEP_ACTIONS_CONFIG = {
  "lsm-dispatched": {
    hasAuthority: (permissionsList, authorizedPerson) => authorizedPerson,
    action: { type: "dialog", title: "Mark as Dispatched" }
  },
  "product-shipped": {
    hasAuthority: (permissionsList) => hasAuthority(["mark-as-product-shipped"], permissionsList),
    action: { type: "dialog", title: "Mark as Shipped" }
  },
  "lsm-shipped": {
    hasAuthority: (permissionsList) => hasAuthority(["in-bound-marked-shipped"], permissionsList),
    action: { type: "dialog", title: "Mark as Shipped" }
  },
  "infusion": {
    hasAuthority: (permissionsList, authorizedPerson) => authorizedPerson,
    action: { type: "dialog", title: "Infusion Date", infusion: true }
  },

  "change-assigned-apheresis-date": {
    hasAuthority: (permissionsList) => hasAuthority(["assign-apheresis-date"], permissionsList),
    action: { type: "action", color: "success", title: "Start Apheresis" }
  }
};

const maintainSteps = (initialSteps = [], permissionsList, authorizedPerson, buttonPop, role_slug, currentCycle, cr_permissions) => {
  const res = [];
  for (let ind in initialSteps) {
    let step = { ...initialSteps[ind] };
    const CR_raise = checkCRExist(initialSteps, ind)
    step.actions = [];
    let stepConfig = step?.change_requests && step?.change_requests?.length > 0;
    // Check if this step matches the target step from config and user has authority & CR permission
    const config = STEP_ACTIONS_CONFIG[step.slug];
    if (
      stepConfig &&
      config &&
      config.hasAuthority(permissionsList, authorizedPerson) &&
      hasCRPermission(cr_permissions, step?.change_requests?.flatMap(it =>
        it?.fields?.map(s => s?.slug) || []), "RESOLVE")
    ) {
      // For infusion step, check if the approved CR is for "complete-infusion-date"
      // If so, open Complete Infusion modal instead of Infusion Date modal
      const isCompleteInfusionCR =
        step.slug === "infusion" &&
        step?.change_requests?.some(cr =>
          cr?.fields?.some(f =>
            f?.slug === "complete-infusion-date" || f?.slug === "change-complte-infusion"
          )
        );
      console.log(isCompleteInfusionCR, "isCompleteInfusionCRisCompleteInfusionCR", step?.change_requests?.some(cr =>
        cr?.fields?.some(f =>
          f?.slug === "complete-infusion-date" || f?.slug === "change-complte-infusion"
        )))
      if (isCompleteInfusionCR) {
        step.actions.push({ type: "dialog", title: "Complete Infusion", completeInfusion: true });
      } else {
        step.actions.push(STEP_ACTIONS_CONFIG[step?.slug]?.action);
      }
      res.push(step);
      continue;
    }
    if (step.status != 2) {
      if (
        step.slug == "lsm-shipped" &&
        initialSteps[ind - 1]?.status === 2 &&
        hasAuthority(["in-bound-marked-shipped"], permissionsList) &&
        buttonPop?.includes("lsm-shipped")
      ) {
        step.actions.push({ type: "dialog", title: "Mark as Shipped" });
      }

      if (
        step.slug == "lsm-received-cdm" &&
        initialSteps[ind - 1]?.status == 2 &&
        authorizedPerson
      ) {
        step.actions.push({ type: "action", title: "Mark as Received", disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : "" });
      }

      if (
        step.slug == "apheresis" &&
        initialSteps[ind - 1]?.status == 2 &&
        authorizedPerson &&
        step.status == 0
      ) {
        step.actions.push({
          disabled: CR_raise,
          type: "action",
          color: "success",
          disabledTitle: CR_raise ? CR_TEXT : "",
          title: "Start Apheresis"
        });
      }

      if (
        step.slug == "lsm-dispatched" &&
        initialSteps[ind - 1]?.status == 2 &&
        authorizedPerson
      ) {
        step.actions.push({ type: "dialog", title: "Mark as Dispatched" });
      }

      if (
        step.slug == "lsm-received-bmr" &&
        initialSteps[ind - 1].status === 2 &&
        hasAuthority(["in-bound-marked-received"], permissionsList) &&
        buttonPop?.includes("lsm-received-bmr")
      ) {
        step.actions.push({
          type: "action",
          color: "success",
          title: "Mark as Received",
          disabled: CR_raise,
          disabledTitle: CR_raise ? CR_TEXT : ""
        });
      }

      if (
        step.slug == "product-manufactured" &&
        initialSteps[+ind + 1]?.status == 0 &&
        initialSteps[ind - 1]?.status == 2 &&
        buttonPop?.includes("product-manufactured") &&
        step.status === 0
      ) {
        if (
          hasAuthority(
            ["failed-manufacturing", "start-manufacturing"],
            permissionsList
          )
        ) {
          step.actions.push({
            type: "dialog", title: "LSM Approval", disabled: CR_raise,
            disabledTitle: CR_raise ? CR_TEXT : ""
          });
        }
      }

      if (
        step.slug == "product-shipped" &&
        initialSteps[ind].status == 1 &&
        hasAuthority(["mark-as-product-shipped"], permissionsList)
      ) {
        step.actions.push({ type: "dialog", title: "Mark as Shipped" });
      }

      if (
        step.slug == "product-received" &&
        initialSteps[ind - 1].status === 2 &&
        authorizedPerson
      ) {
        step.actions.push({ type: "action", title: "Mark as Received", disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : "" });
      }

      if (
        step.slug == "infusion" &&
        initialSteps[ind].status === 4 &&
        authorizedPerson
      ) {
        step.actions.push({
          type: "dialog",
          color: "success",
          title: "Complete Infusion",
          completeInfusion: true,
          disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : ""
        });
      }

      if (
        authorizedPerson &&
        step.slug == "infusion" &&
        buttonPop?.includes("add_infusion_date") &&
        step.status == 0 &&
        step?.is_publish == 1 &&
        !step?.infusion_date
      ) {
        step.actions.push({
          type: "dialog",
          title: "Infusion Date",
          disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : "",
          infusion: true
        });
      }
    }

    if (
      step.slug == "product-manufactured" &&
      initialSteps[ind - 1]?.status === 2
    ) {
      StepStatus[3] = "Failed";

      if (
        (initialSteps[ind].status === 6 ||
          initialSteps[ind].status === 8) &&
        hasAuthority(["start-manufacturing"], permissionsList) &&
        buttonPop?.includes("start-manufacturing")
      ) {
        step.actions.push({
          type: "dialog",
          start: true,
          title: "Start Manufacturing",
          disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : ""
        });

        if (initialSteps[ind].status === 8) {
          step.actions.push({
            type: "dialog",
            cryo: true,
            title: "Cryopreserve LSM",
            color: "warning",
            disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : ""
          });
        }
      } else if (initialSteps[ind].status == 4) {
        if (
          hasAuthority(["completed-manufacturing"], permissionsList) &&
          buttonPop?.includes("start-manufacturing") &&
          currentCycle?.status != 2 &&
          currentCycle?.status != 0
        ) {
          step.actions.push({
            type: "dialog",
            color: "success",
            marks: true,
            title: "Mark as Completed",
            disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : ""
          });
        }
      }

      if (
        initialSteps[ind].status >= 1 &&
        initialSteps[ind].status !== 8
      ) {
        if (
          initialSteps[ind].re_manufacture_status != 0 &&
          hasAuthority(["start-manufacturing"], permissionsList) &&
          buttonPop?.includes("start-manufacturing") &&
          step.status !== 6 &&
          currentCycle?.status != 2 &&
          currentCycle?.status != 0
        ) {
          step.actions.push({
            type: "dialog",
            extra: true,
            title: "Re-Manufacturing",
            disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : ""
          });

          step.actions.push({
            type: "dialog",
            finishProduct: true,
            title: "Print"
          });
        }
      }

      const nextStep = initialSteps[parseInt(ind) + 1];
      const nextToNext = initialSteps[parseInt(ind) + 2];

      if (
        ((nextStep?.slug === "qc-testing" &&
          nextStep?.status == 3) ||
          (nextToNext?.slug === "qa-review" &&
            nextToNext?.status == 3)) &&
        initialSteps[parseInt(ind) - 1]?.status == 2 &&
        buttonPop?.includes("start-manufacturing")
      ) {
        if (
          hasAuthority(["start-manufacturing"], permissionsList) &&
          initialSteps[parseInt(ind) - 1].re_manufacture_status != 0
        ) {
          step.actions.push({
            type: "dialog",
            extra: true,
            title: "Re-Manufacturing",
            disabled: CR_raise, disabledTitle: CR_raise ? CR_TEXT : ""
          });

          step.actions.push({
            type: "dialog",
            finishProduct: true,
            title: "Print"
          });
        }
      }
    }

    if (
      step.slug == "qc-testing" &&
      hasAuthority(["product-published"], permissionsList) &&
      ((step.status === 2 &&
        initialSteps[ind - 1].status === 2 &&
        (initialSteps[ind].status !== 3 &&
          step.product_completed_date == null)) || (step?.change_requests && step?.change_requests?.length > 0 && step?.cr_status == 'pending'))
    ) {
      step.actions.push({ type: "action", title: "Publish", disabledTitle: CR_raise ? CR_TEXT : "" });
    }

    if (
      step.slug == "qa-review" &&
      initialSteps[ind - 1].product_completed_date != null &&
      ["quality-associate"]?.includes(role_slug)
    ) {
      step.actions.push({
        type: "dialog",
        print: true,
        title: "Batch Release Print"
      });
    }

    res.push(step);
  }

  return res;
};




const ProgressTracker = ({
  steps,
  onAction,
  FormComponent = null,
  onUpdate,
  id = null,
  patient_id = null,
  formProps = undefined,
  buttonPop = [],
  onDirectPrint = null
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const batchU = searchParams.get('batch');
  const activeV2VCycle = useSelector(selectActiveV2VCycle) || 0;
  const V2VCycle = useSelector(selectV2VCycle);
  const vienToVienLoading = useSelector(selectVienToVienLoading);
  const manufactureProductLoading = useSelector(selectManufactureProductLoading);
  const deliveryPartnerOptions = useSelector(selectDeliveryActivePartnersAll) || [];
  const [historyOpen, setHistoryOpen] = useState(false);
  const [actualSteps, setActualSteps] = useState([]);
  const [stepSlug, setStepSlug] = useState(null);
  const [extraModel, setExtraModel] = useState(null);
  const [cryoModel, setCryoModel] = useState(false)
  const [infusionModal, setInfusionModal] = useState(false);
  const [completeInfusionModal, setCompleteInfusionModal] = useState(false);
  const [markModel, setMarkModel] = useState(false);
  const [startModel, setStartModel] = useState(false);
  const [open, setOpen] = useState(false);
  const currentCycle = useSelector(selectCurrentCycle);
  const [publishModal, setPublishModal] = useState(false)
  const publishClickedRef = useRef(false);
  const [tabCycleChange, setTabCycleChange] = useState(false)
  const [dialogTitle, setDialogTitle] = useState("Marked as Shipped");
  const { bmr_permissions, role_slug, cr_permissions } = useSelector((state) => state.loginData);
  const authorizedPerson = ['editor', 'project-manager']?.includes(role_slug);
  const activeTaskSlug = useSelector(selectActiveTaskSlug);
  const dispatch = useDispatch();

  const [prefilledValues, setPrefilledValues] = useState(null);
  const [isChangeRequestApproval, setIsChangeRequestApproval] = useState(false);


  const handleChange = (event, newValue) => {
    const indexFromTab = Number(newValue);
    const selectedCycle = V2VCycle?.[indexFromTab];

    const selectedBatch = selectedCycle?.batch_no
      || selectedCycle?.batchNo
      || selectedCycle?.batch;

    setTabCycleChange(true);
    dispatch(changeV2VCycle({ index: indexFromTab, cycle: V2VCycle }));

    if (selectedBatch) {
      const params = new URLSearchParams(searchParams.toString());
      params.set("batch", String(selectedBatch).trim());
      setSearchParams(params);
    }
  };

  useEffect(() => {
    setActualSteps(maintainSteps(steps, bmr_permissions, authorizedPerson, buttonPop, role_slug, currentCycle, cr_permissions));
  }, [steps, bmr_permissions, authorizedPerson, activeV2VCycle, currentCycle, role_slug, activeTaskSlug, cr_permissions]);
  /*
      useEffect(() => {
      if (V2VCycle && V2VCycle?.length > 0 && activeV2VCycle > V2VCycle?.length - 1)
        dispatch(changeV2VCycle({ index: 0, cycle: V2VCycle }))
    }, [V2VCycle])
  */

  useEffect(() => {
    if (!V2VCycle?.length) return;
    if (batchU?.trim() && !tabCycleChange) {
      const batchIndex = V2VCycle.findIndex((it) => it?.batch_no == batchU.trim());
      if (batchIndex !== -1 && batchIndex !== activeV2VCycle) {
        dispatch(changeV2VCycle({ index: batchIndex, cycle: V2VCycle }));
      }
      return;
    }
    if (activeV2VCycle > V2VCycle.length - 1 || activeV2VCycle < 0) {
      dispatch(changeV2VCycle({ index: 0, cycle: V2VCycle }));
    }
  }, [V2VCycle, batchU, activeV2VCycle, tabCycleChange, dispatch]);

  const StepIconComponent = ({ completed }) => (
    <StepIconWrapper completed={completed}>
      {completed && <InnerCircle completed />}
    </StepIconWrapper>
  );

  const handleClose = () => {
    setOpen(false);
    setCryoModel(false);
    setStartModel(false);
    setExtraModel(false);
    setInfusionModal(false);
    setCompleteInfusionModal(false);
    setMarkModel(false);
    setPublishModal(false);
    setPrefilledValues(null);
    setIsChangeRequestApproval(false);
    setFieldStates({});
  };

  const handleSubmit = () => {
    onUpdate();
    handleClose();
    dispatch(clearActiveTaskSlug());
  };

  useEffect(() => {
    return () => {
      dispatch(clearActiveTaskSlug());
    };
  }, [dispatch]);
  const defaultOpen = (action, step) => {
    setOpen(true);
    setStepSlug(step.slug);
    setDialogTitle(action.title);
  }

  const handleStepActionClick = async (action, step) => {
    if (action.title === "Publish") {
      if (publishClickedRef.current) return;
      publishClickedRef.current = true;
      onAction?.(step);
      setTimeout(() => {
        publishClickedRef.current = false;
      }, 500);
      return;
    }
    if (action.completeInfusion) {
      setCompleteInfusionModal(true);
      defaultOpen(action, step);
      return;
    }
    if (action.infusion) {
      setInfusionModal(true);
      defaultOpen(action, step);
      return;
    }

    if (STEP_ACTIONS_CONFIG[step?.slug] && step?.change_requests?.length > 0) {
      let deliveryPartnerId = step?.delivery_partner_id;
      if (!deliveryPartnerId && step?.delivery_partner_name) {
        const matchedPartner = deliveryPartnerOptions.find(
          partner => partner.label?.toLowerCase() === step?.delivery_partner_name?.toLowerCase()
        );

        if (matchedPartner) {
          deliveryPartnerId = matchedPartner.value;
        }
      }

      const prefilled = {
        delivery_partner_id: deliveryPartnerId?.toString() || "",
        awb: step?.awb || "",
        tracking_link: step?.tracking_link || "",
        cr_id: step?.change_requests?.map((it) => it?.id)
      };

      setPrefilledValues(prefilled);

      let fieldStates = {};
      const isBulkOperation = Array.isArray(step?.change_requests) && step?.change_requests?.length > 0;
      if (isBulkOperation) {
        // For bulk operations, check all variations of each field type
        fieldStates = {
          cr_id: step?.change_requests?.map((it) => it?.id),
          delivery_partner_id: !step?.change_requests?.some(it =>
            it?.fields?.some(s => slugMap?.delivery_partner_id?.includes(s?.slug))
          ),
          awb: !step?.change_requests?.some(it =>
            it?.fields?.some(s => slugMap?.awb?.includes(s?.slug))
          ),
          tracking_link: !step?.change_requests?.some(it =>
            it?.fields?.some(s => slugMap?.tracking_link?.includes(s?.slug))
          ),
        };
      }
      setIsChangeRequestApproval(true);
      setFieldStates(fieldStates);
      // Open the modal
      setOpen(true);
      setStepSlug(step.slug);
    } else {

      // Open modal for non-change requests
      switch (action.type) {
        case "dialog":
          switch (true) {
            case action.extra:
              setExtraModel(true);
              defaultOpen(action, step);
              break;
            case action.start:
              setStartModel(true);
              defaultOpen(action, step);
              break;
            case action.cryo:
              setCryoModel(true);
              defaultOpen(action, step);
              break;
            case action.marks:
              setMarkModel(true);
              defaultOpen(action, step);
              setDialogTitle("Date of Manufacturing");
              break;
            case action.infusion:
              setInfusionModal(true);
              defaultOpen(action, step);
              break;
            case action.finishProduct:
              onDirectPrint?.(true);
              break;
            case action.print:
              setPublishModal(true);
              break;
            default:
              setOpen(true);
              setStepSlug(step.slug);
              setDialogTitle(action.title);
              break;
          }
          break;
        case "action":
          onAction?.(step);
          break;
        default:
          break;
      }
    }
  };
  const [fieldStates, setFieldStates] = useState({});



  return (
    <Box sx={{ width: '100%', typography: 'body1' }} className="bg-white rounded-xl">
      <TabContext value={String(activeV2VCycle)}>
        <Box
        >
          <Box className="bg-[#E8EFFC]">
            <TabList
              value={String(activeV2VCycle)}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="scrollable auto tabs example"
              onChange={handleChange}
              sx={{ marginBottom: "-1px" }}
              TabIndicatorProps={{ style: { display: "none" } }} // remove default underline
            >
              {V2VCycle?.map((tab, index) => (
                <Tab
                  key={tab?.cycle}
                  value={String(index)}
                  label={
                    <div className="flex items-center gap-2">
                      <span
                        className={`flex gap-2 ${activeV2VCycle === index
                          ? "text-blue-600 font-semibold"
                          : "text-black"
                          }`}
                      >
                        {tab?.type == 1 ? <FreshIcon color={activeV2VCycle === index ? "#3571FF" : "#000"} /> : tab?.type == 3 ? <PoolIcon color={activeV2VCycle === index ? "#3571FF" : "#000"} /> : <Cryopreserve color={activeV2VCycle === index ? "#3571FF" : "#000"} />} {tab.cycle}
                      </span>
                      <Chip color={tab.status == 0 || tab.status == 2 ? "error" : "success"} className={`${CycleStatusColor[tab.status]}`} label={CycleStatus[tab?.status]} />
                    </div>
                  }
                  style={activeV2VCycle === index ? {
                    borderTop: "#3571FF solid 1px",
                    borderRight: "#3571FF solid 1px",
                    borderLeft: "#3571FF solid 1px",
                    backgroundColor: "white"
                  } : { border: "transparent" }}
                  className={`normal-case px-4 py-2 rounded-t-lg transition`}
                />
              ))}
            </TabList>
          </Box>
        </Box>
        {V2VCycle?.map((tabData, index) => (
          <TabPanel key={tabData?.cycle} value={String(index)} sx={{ borderTop: "1px solid rgb(53, 113, 255)" }}>
            <ReferenceSection
              onUpdate={onUpdate}
              key={'_refrence_' + index}
              subject_id={formProps?.subject_id || patient_id}
              onDirectPrint={onDirectPrint}
              actualSteps={actualSteps}
            />
            <Card className="shadow-none bg-[#FAFAFA] border-2">
              <CardContent className="pr-0 relative">
                <Tooltip
                  title="History"
                >
                  <div
                    className="absolute right-3 top-1 cursor-pointer z-[1]"

                    onClick={() => setHistoryOpen(true)}
                  >
                    <HistoryIcon />
                  </div>
                </Tooltip>
                <Stepper alternativeLabel connector={<BarConnector />}>
                  {actualSteps?.map((step, key) => (
                    <Step key={key} completed={step.status === 2}>
                      <Tooltip
                        componentsProps={{
                          tooltip: {
                            sx: {
                              padding: 0,
                              minWidth: 250,
                              borderRadius: "0.95rem",
                              bgcolor: "white",
                              color: "text.primary",
                              boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                              position: "relative",
                            },
                            className: "custom-tooltip",
                          },
                          arrow: {
                            sx: {
                              color: "white",
                              "&:before": {
                                boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.2)",
                              },
                            },
                          },
                        }}
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: "offset",
                                options: {
                                  offset: [0, -8], // Adjust vertical offset as needed
                                },
                              },
                            ],
                          },
                        }}
                        placement="top"
                        title={RenderTooltipContent(step?.stepsDetails, step?.name)}
                        arrow
                        disableHoverListener={!step.stepsDetails?.status}
                      >
                        <StepLabel
                          StepIconComponent={StepIconComponent}
                          className={`items-start ${step.stepsDetails ? " cursor-pointer" : ""
                            }`}
                          slotProps={{
                            label: {
                              sx: { marginTop: "10px!important" },
                            },
                          }}
                        >
                          <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4">
                            <div className="flex flex-col items-start">
                              <div className="text-[10px] sm:text-[11px] text-[#ABB7C2] text-left">{`STEP ${key + 1
                                }`}</div>
                              <div className="text-[10px] sm:text-[13px] text-[#0D0B26] text-left break-words">
                                {step.name}
                              </div>
                              <div className="text-[10px] sm:text-[11px] text-[#ABB7C2] text-left flex-col flex">
                                {(step.expected_date || step.started_date) && <span>Expected: {dateFormater(step.expected_date || step.started_date)}</span>}

                                {step.infusion_date &&
                                  (<div className="block text-orange-600"><span className="text-orange-600">Infusion Date: </span><span>{dateFormater(step.infusion_date)}</span></div>)}

                                {/* {step.slug === 'infusion' && (currentCycle?.complete_date || step.completed_date) && (
                                  <div className="block text-green-600">
                                    <span className="text-green-600">Complete Infusion Date: </span>
                                    <span>{dateFormater(currentCycle?.complete_date || step.completed_date)}</span>
                                  </div>
                                )} */}
                                {!step.tracking_link && step?.awb && <Tooltip
                                  title={step?.awb}
                                ><span>{truncateText(step?.awb, 12)}</span></Tooltip>}

                                {step?.tracking_link && step?.awb && (
                                  <a
                                    href={step?.tracking_link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="text-[blue] underline"
                                  >
                                    {step?.awb && <Tooltip
                                      title={step?.awb}
                                    ><span>{truncateText(step?.awb, 12)}</span></Tooltip>}
                                  </a>
                                )}
                              </div>
                              <div
                                className={`text-[10px] sm:text-[11px] text-left ${StepStatusColor[step.status]
                                  }`}
                              >
                                {StepStatus[step.status]}
                              </div>
                              {step.trackingID && (
                                <div className="text-[10px] sm:text-[11px] text-left">
                                  {step.trackingID}
                                </div>
                              )}

                              {step.actions?.map((action, i) => (
                                <LoadingButton
                                  key={i}
                                  loading={action?.title !== "Publish" &&  (vienToVienLoading || manufactureProductLoading)}
                                  variant="contained"
                                  size="small"
                                  className={`mt-2 sm:mt-0 text-[9.5px] w-full sm:w-auto 
                              ${action.color === "error" ? "bg-red-600 hover:bg-red-700" : ""}
                              ${action.color === "success" ? "bg-green-600 hover:bg-green-700" : ""}
                              ${action.color === "primary" ? "bg-blue-600 hover:bg-blue-700" : ""}
                               ${action.color === "warning" ? "bg-yellow-400 hover:bg-yellow-500" : ""}
                              transform transition-all duration-300 hover:-translate-y-1 hover:shadow-lg
                            `}
                                  sx={{
                                    ...(action?.title === "Publish" && publishClickedRef.current && {
                                      cursor: "not-allowed !important",
                                      pointerEvents: "auto !important",
                                    })
                                  }}
                                  disabled={action?.disabled}
                                  onClick={() => handleStepActionClick(action, step)}
                                >
                                  <Tooltip title={action?.disabled ? action?.disabledTitle : action.title}>{action.title}</Tooltip>
                                </LoadingButton>

                              ))}
                              <span className="text-success">
                                {step.slug === 'infusion'
                                  ? (currentCycle?.complete_date || step.completed_date) && dateFormater(currentCycle?.complete_date || step.completed_date)
                                  : step.completed_date && dateFormater(step.completed_date)
                                }
                              </span>
                            </div>
                          </div>
                        </StepLabel>
                      </Tooltip>
                    </Step>
                  ))}
                </Stepper>
              </CardContent>
              <HistoryDrawer
                open={historyOpen}
                onClose={() => setHistoryOpen(false)}
                patient_id={patient_id}
              />
              <BsModal
                fullWidth={true}
                open={open}
                size={startModel ? 'sm' : cryoModel ? 'md' : "xs"}
                onClose={handleClose}
                title={dialogTitle}
              >
                {FormComponent && !markModel && !extraModel && !startModel && !infusionModal && !completeInfusionModal && !cryoModel && !publishModal && (
                  <FormComponent
                    handleFormSubmit={handleSubmit}
                    setOpen={setOpen}
                    feasibility_id={id}
                    stepSlug={stepSlug}
                    initialValues={isChangeRequestApproval ? {
                      delivery_partner_id: prefilledValues?.delivery_partner_id?.toString(),
                      awb: prefilledValues?.awb,
                      tracking_link: prefilledValues?.tracking_link,
                      cr_id: prefilledValues?.cr_id,
                    } : undefined}
                    fieldStates={isChangeRequestApproval ? fieldStates : undefined}
                    {...formProps}
                  />
                )}
                {extraModel && <RestartManufacturingForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                {startModel && <StartManufacturingForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                {markModel && <MarkAsCompleteForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                {infusionModal && <InfusionDateForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  type={markModel ? 'mark' : 'infusion'}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                {completeInfusionModal && <CompleteInfusionForm
                  handleFormSubmit={handleSubmit}
                  setOpen={setOpen}
                  feasibility_id={id}
                  stepSlug={stepSlug}
                  {...formProps}
                />}

                {cryoModel && <CryoLsmFormDialog id={formProps?.subject_id} setOpen={setOpen} formProps={formProps} getTimeLine={handleSubmit} />}
              </BsModal>
            </Card>
            {publishModal && (
              <BatchReleaseCertificate
                open={publishModal}
                onClose={() => {
                  setPublishModal(false);
                }}
              />
            )}
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};

export default ProgressTracker;